import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/index.js'
import illusroutes from './routes/routes-illustrators.js'
import animroutes from './routes/routes-animators.js'
import ixr from '@/components/navigation/ixrouter.js'
import langs from '@/data/langs'
import kk from '@/constants.js'
import gtag from '@/gtag/gtag.js'

Vue.use(Router)

function setCanonical(to) {
  let cnc = document.getElementById('cnc')
  if(cnc) {
    cnc.rel = 'canonical'
    cnc.href = 'https://' + window.location.host + to.path
  }
}


async function locateArtistPage(url, next) {
  
  const artists = await store.dispatch('fetchArtists')
  if(url === 'contact') {
    next('/contact/' + store.state.lang.toLowerCase())
    return
  }
  let ul = url.toLowerCase()
  if(ul.indexOf('/') === 2) {
    ul = ul.split('/').pop()
  }
  for(let artist of artists) {
    if(ul === artist.portfolio_url.toLowerCase()){
      if(artist.illustrator) {
        next(ixr.getPushPath('/artists/' + artist.portfolio_url))
        return
      }
      else {
        next(ixr.getPushPath('/animators/' + artist.portfolio_url))
        return
      }
    }
  }
  
  window.location = '/notfound.html'
}


const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang?/animated',
      redirect: {
        name: 'animation style gallery',
        params: {
          url: 'animated-(animated-by-others)'
        }
      }
    },
    {
      path: '/animation',
      component: () => import( '@/views/AnimationNav.vue'),
      children: animroutes
    },
    {
      path: '/',
      component: Home,
      children: illusroutes
    },
    {
      path: '/artist-image-list/:name',
      name: 'artist image list ssr',
      component: () => import('@/views/ssr/ArtistImageList.vue'),
      props: true
    },
    {
      path: '/artist-login',
      name: 'uni artist login',
      component: () => import('@/views/admin/ArtistLogin.vue')
    },
    {
      path: '/weeklyportfolio',
      beforeEnter: async (to, from, next) => {
        let ret = await store.dispatch('fetchSetting', 'weekly')
        next(ret)
      }
    },
    {
      path: '/*',
      name: 'catch-all',
      beforeEnter: (to, from, next) => {
        if(to.params.pathMatch) {
          locateArtistPage(to.params.pathMatch, next)
        }
        else {
          //next('/not-found')
          window.location = '/notfound.html'
        }
        
      }
    }
  ]
})

function fulfillScroll(savedPosition){
  store.commit('setRequestedScrollY', 0)
  return savedPosition;
}

router.options.scrollBehavior = function (to, from, savedPosition) {
  try {
    if(to.name && from.name) {
      if(from.name.startsWith('video')){
        if(to.name.startsWith('video')) {
          return
        }
      }
      else if(to.name.indexOf('home page') > 0) {
        return { x: 0, y: 0 }
      }
      else if(to.name === 'about us') {
        return { x: 0, y: 0 }
      }
    }
    if(!savedPosition) {
      return { x: 0, y: 0 }
    }
    else {
      store.commit('setRequestedScrollY', savedPosition.y)
      return new Promise((resolve, reject) => {
        try {
          setTimeout(() => {
            resolve(fulfillScroll(savedPosition))
          }, 50)
        }
        catch(error) {
          reject('Unable to set timeout')
        }
      })
      
      
    }
  }
  catch(err) {
    console.log('scroll prob', err)
  }
}

router.beforeEach((to, from, next) => {
  store.commit('setShowTestimonialButton', false)
  store.commit('setFromPage', from.path)
  kk.setMetatags('IllustrationX','')
  if((to.path.indexOf('not-found') < 0) || ((to.path.indexOf('notfound.html')) < 0)){
    setCanonical(to)
    if(to.params.lang) {
      if(!langs.navlangs.includes(to.params.lang)){
        let path = ixr.path
        if(!store.state.langPref) {
          store.commit('setLang', 'UK')
        }
        next(path)
        return
      }
      else {
        if(!store.state.langPref){
          store.commit('setLang', to.params.lang.toUpperCase())
        }
      }
    }
    else {
      let lang = ixr.getLangFromPath(to.path)
      if(!store.state.langPref) {
        store.commit('setLang', lang)
      }
      else {
        store.commit('setLang', store.state.langPref)
      }
    }
  }
  gtag.loadGoogle(to, store)
  next()
})

export default router


